import { render, staticRenderFns } from "./requestAddress.vue?vue&type=template&id=0e113fb4&"
import script from "./requestAddress.vue?vue&type=script&lang=js&"
export * from "./requestAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports